module.exports = __webpack_public_path__ + "img/lottery_record.b76490d1.svg";